import DashboardMockup from "./DashboardMockup";
import { ArrowRight, ShieldCheck } from "lucide-react";

const badges = [
    "Gestione interventi e rapportini",
    "Contratti prepagati e flat",
    "Servizi MSP e licenze",
    "Portale cliente",
    "Report e KPI",
    "Log e tracciabilità",
];

export default function Hero() {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative overflow-hidden bg-gradient-to-br from-[#0B1120] via-[#0e1628] to-[#0f172a] text-white grain"
        >
            {/* Grid background */}
            <div className="absolute inset-0 grid-bg opacity-70" aria-hidden />
            {/* Ambient blobs */}
            <div className="absolute -top-32 -left-32 w-[36rem] h-[36rem] rounded-full bg-cyan-500/10 blur-3xl" aria-hidden />
            <div className="absolute -bottom-32 -right-24 w-[30rem] h-[30rem] rounded-full bg-teal-500/10 blur-3xl" aria-hidden />

            <div className="relative max-w-7xl mx-auto px-6 lg:px-8 pt-28 sm:pt-32 lg:pt-36 pb-20 lg:pb-28">
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 items-center">
                    <div className="lg:col-span-6 xl:col-span-6">
                        <span
                            data-testid="hero-eyebrow"
                            className="inline-flex items-center gap-2 rounded-full bg-white/5 backdrop-blur border border-white/10 px-3.5 py-1.5 text-[11.5px] font-semibold uppercase tracking-widest text-cyan-300"
                        >
                            <ShieldCheck className="w-3.5 h-3.5" />
                            Gestionale operativo per aziende IT
                        </span>

                        <h1
                            data-testid="hero-headline"
                            className="mt-6 font-display text-4xl sm:text-5xl lg:text-[3.75rem] xl:text-[4.25rem] font-extrabold leading-[1.02] tracking-tight text-white"
                        >
                            Il gestionale che mette{" "}
                            <span className="relative inline-block">
                                <span className="bg-gradient-to-r from-cyan-300 via-cyan-400 to-teal-300 bg-clip-text text-transparent">
                                    ordine
                                </span>
                                <svg
                                    className="absolute -bottom-2 left-0 w-full"
                                    height="10"
                                    viewBox="0 0 200 10"
                                    fill="none"
                                    aria-hidden
                                >
                                    <path
                                        d="M2 6 Q 60 -2, 120 5 T 198 4"
                                        stroke="url(#g)"
                                        strokeWidth="3"
                                        strokeLinecap="round"
                                    />
                                    <defs>
                                        <linearGradient id="g" x1="0" x2="1">
                                            <stop offset="0%" stopColor="#06b6d4" />
                                            <stop offset="100%" stopColor="#14b8a6" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </span>{" "}
                            nel lavoro quotidiano delle aziende IT.
                        </h1>

                        <p
                            data-testid="hero-subtitle"
                            className="mt-6 text-lg sm:text-xl text-slate-300 leading-relaxed max-w-2xl"
                        >
                            TecSuite concentra interventi, rapportini, contratti, servizi MSP,
                            dispositivi, preventivi, scadenze e portale cliente in un&apos;unica
                            piattaforma costruita intorno ai processi reali di chi fa
                            assistenza tecnica.
                        </p>

                        <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-3">
                            <a
                                href="#contatti"
                                data-testid="hero-cta-primary"
                                className="group inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-cyan-500 to-teal-400 hover:from-cyan-400 hover:to-teal-300 text-slate-950 px-6 py-3.5 text-sm font-bold shadow-lg shadow-cyan-500/25 transition"
                            >
                                Richiedi una demo
                                <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition" />
                            </a>
                            <a
                                href="#moduli"
                                data-testid="hero-cta-secondary"
                                className="inline-flex items-center gap-2 rounded-full bg-white/5 hover:bg-white/10 backdrop-blur border border-white/15 px-6 py-3.5 text-sm font-semibold text-white transition"
                            >
                                Scopri i moduli
                            </a>
                        </div>

                        <div
                            data-testid="hero-badges"
                            className="mt-10 flex flex-wrap gap-2"
                        >
                            {badges.map((b) => (
                                <span
                                    key={b}
                                    className="inline-flex items-center gap-1.5 rounded-full bg-white/5 border border-white/10 px-3 py-1.5 text-[12px] font-medium text-slate-300"
                                >
                                    <span className="h-1.5 w-1.5 rounded-full bg-teal-400" />
                                    {b}
                                </span>
                            ))}
                        </div>
                    </div>

                    <div className="lg:col-span-6 xl:col-span-6 relative">
                        <DashboardMockup />
                    </div>
                </div>
            </div>

            {/* Divider */}
            <div className="relative h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
        </section>
    );
}
